export default "__VITE_ASSET__4bfcc4d2__"